export default __webpack_public_path__ + "3706af12de4a9d8231414f2c9db499c5.svg";